export class InteractionEquationModel {
    _id: string;
    name: string;
    codeBased: boolean;
    equation: string;

    constructor(id = null,
        name = '',
        codeBased = false,
        equation = '') {
            this._id = id;
            this.name = name;
            this.codeBased = codeBased;
            this.equation = equation;
    }
}
